import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {AffiliateCode} from "../../../shared/interface/affiliateCode";
import {HiperioParameterConfig, HiperioRegistrationConfig} from "../../../shared/interface/hiperio-registration-config";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {AuthService} from "../../../shared/services/auth.service";
import {MatDialog} from "@angular/material/dialog";
import {LicensedAgentService} from "../../../shared/services/licensed-agent.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Router} from "@angular/router";
import {DictService} from "../../../shared/services/dict.service";
import {AffiliateCodeService} from "../../../shared/services/affiliate-code.service";
import {takeUntil} from "rxjs/operators";
import {ChangeRegistrationHiperioDialogComponent} from "../change-registration-dialog/change-registration-hiperio-dialog.component";
import {ChangeParameterDialogComponent} from "../change-parameter-dialog/change-parameter-dialog.component";
import {Employee} from "../../../shared/interface/employee";
import {HttpErrorResponse} from "@angular/common/http";
import {AgentsProfileHiperioService} from "../../../shared/services/agents-profile-hiperio.service";
import {a, co, cp} from "@fullcalendar/core/internal-common";

@Component({
  selector: 'app-hiperio-registration-config-details-view',
  templateUrl: './hiperio-registration-config-details-view.component.html',
  styleUrls: ['./hiperio-registration-config-details-view.component.scss']
})
export class HiperioRegistrationConfigDetailsViewComponent implements OnInit, OnDestroy {
  @Input() hiperioRegistrationConfig: Observable<HiperioRegistrationConfig>;
  @Output() modifyClicked = new EventEmitter<any>();

  userPermissions: ReplaySubject<UserPermissions>;
  userPermissionss: UserPermissions;
  hiperioRegistrationConfigObject?: HiperioRegistrationConfig;
  parameter?: HiperioParameterConfig;
  credentialDataList: any[] = [];
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private auth: AuthService,
    private dialog: MatDialog,
    private licensedAgentService: LicensedAgentService,
    private snack: MatSnackBar,
    private router: Router,
    private dictService: DictService,
    private affiliateCodeService: AffiliateCodeService,
    private agentsProfileHiperioService: AgentsProfileHiperioService,
  ) {
    this.auth.getUserPermissions()
      .subscribe((userPermissions: UserPermissions) => {
        this.userPermissionss = userPermissions;
      });
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.hiperioRegistrationConfig
      .pipe(takeUntil(this.destroyed$))
      .subscribe((hiperioRegistrationConfig: HiperioRegistrationConfig) => {
        this.hiperioRegistrationConfigObject = hiperioRegistrationConfig;
        if (this.userPermissionss.hiperio.read && this.hiperioRegistrationConfigObject.registration) {
          this.agentsProfileHiperioService.getParameter(this.hiperioRegistrationConfigObject.ofwca?.hiperioAgencyUnitsUuid,
            this.hiperioRegistrationConfigObject.productId).subscribe((parameter: HiperioParameterConfig) => {
            this.parameter = parameter;
          }, (error: HttpErrorResponse) => {
            this.snack.open('Nie udało się pobrać danych', error.status.toString(), {
              duration: 2000
            });
          });

          this.agentsProfileHiperioService.getCredentials(this.hiperioRegistrationConfigObject.ofwca?.hiperioAgencyUnitsUuid,
            this.hiperioRegistrationConfigObject.productId).subscribe((value) => {
            this.credentialDataList = value[0]['credentialData'];
          }, (error: HttpErrorResponse) => {
            this.snack.open('Nie udało się pobrać danych', error.status.toString(), {
              duration: 2000
            });
          });
        }
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  changeRegistration(): void {
    const dialogRef = this.dialog.open(ChangeRegistrationHiperioDialogComponent, {
      width: '80vw',
      maxHeight: '90vh',
      data: {
        partnerId: this.hiperioRegistrationConfigObject.ofwca?.partner?.uuid,
        ofwca: this.hiperioRegistrationConfigObject.ofwca,
        insuranceCompany: this.hiperioRegistrationConfigObject.insuranceCompany,
        hiperioRegistrationConfigId: this.hiperioRegistrationConfigObject.id },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.modifyClicked.emit();
    });
  }

  changeParameter(): void {
    const dialogRef = this.dialog.open(ChangeParameterDialogComponent, {
      width: '80vw',
      maxHeight: '90vh',
      data: {
        parameter: this.parameter
      },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.modifyClicked.emit();
    });
  }
}
